import {FC} from 'react'
import {Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'

interface ExportOrderButtonProps {
  isLoading?: boolean
  onClick: () => void
}

export const ExportOrderButton: FC<ExportOrderButtonProps> = (props) => {
  const {t} = useTranslation()

  return (
    <button
      className='btn btn-primary ms-2'
      data-bs-toggle='tooltip'
      data-bs-placement='top'
      data-bs-trigger='hover'
      title={t('unduh')}
      onClick={props.onClick}
      disabled={props.isLoading}
    >
      {props.isLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Unduh')}
    </button>
  )
}
